import { HelpTooltip, Price as PriceTemplate, Discount } from "components/index"
import { OfferedService, Psychologist } from "utils/interfaces"
import { PublicServicePrice } from "modules/SelectionOfPsychologists/components/Card/PublicServicePrice"
import { getPublicServices } from "utils/helpers/psychologistUtil"

interface PriceAndDiscountProps {
    psy: Psychologist
}

export function PriceAndDiscount(props: PriceAndDiscountProps) {
    const publicServices = getPublicServices(props.psy.offered_services)

    if (publicServices.length == 0) return null

    return (
        <span className="is-flex is-align-items-center">
            <PriceTemplate psy={props.psy} />
            <span className="ml-2">
                <HelpTooltip
                    placement="bottom"
                    overlay={
                        <>
                            {publicServices.map((service: OfferedService) => (
                                <PublicServicePrice
                                    key={service.id}
                                    psy={props.psy}
                                    service={service}
                                />
                            ))}
                        </>
                    }
                />
            </span>
            <Discount className="ml-2 price-and-discount__discount-strikethrough" psy={props.psy} />
        </span>
    )
}
